<template>
    <div class="bom-detail">
      <div class="bom-detail-loading fh center" v-if="loadingBomDetail">
        <loading-circle />
      </div>
      <template v-else>
        <div class="bom-detail-bar v-center space-between">
          <div class="bom-detail-bar-title v-center">
            <img
              class="mr-3"
              src="~@/assets/images/icons/arrow-back.svg"
              width="20px"
              alt=""
              @click="goBack"
            />
            <span
              class="elipsis-text"
              style="max-width: 250px"
              v-overflow-tooltip
            >
             {{ bomName }}
            </span>
            <select
              class="bom-detail-version"
              v-if="getBomVersionsList.length"
              v-model="bomVersionId"
              @change="changeBomVersion"
            >
              <option
                v-for="bomVersion in getBomVersionsList"
                :key="bomVersion.id"
                :value="bomVersion.id"
              >
                V-{{ bomVersion.version_no }}
                {{
                  bomVersion.state === 3
                    ? "(Checkout)"
                    : bomVersion.released
                    ? "(Released)"
                    : bomVersion.active
                    ? "(Latest)"
                    : ""
                }}
              </option>
            </select>
            <div class="inherit" v-if="inheritedFrom">
              <img
                v-if="inheritedFrom?.bomVersionActive"
                class="mx-2"
                src="@/assets/images/icons/info-icon.svg"
                width="22px"
              />
              <img
                v-else
                class="mx-2"
                src="@/assets/images/icons/alert-info-icon.svg"
                width="22px"
                @click="
                  showCheckInButton &&
                    updateInheritedBom(
                      inheritedFrom?.bomName,
                      inheritedFrom?.bomVersion
                    )
                "
              />
              <div class="inherit-message">
                Bom
                {{ bomName }}
                is inherited from
                <router-link
                  :to="`/bom/product/${selectedProductCode}/copy-bom/${inheritedFrom?.bomId}?bomVersionId=${inheritedFrom.bomVersionId}`"
                >
                  {{ inheritedFrom?.bomName }} {{ inheritedFrom?.bomVersion }}
                  {{ inheritedFrom?.bomVersionActive ? "( Latest )" : "" }}
                </router-link>
                {{ inheritedFrom?.bomVersionActive ? "." : " is outdated." }}
                <span
                  v-if="!inheritedFrom?.bomVersionActive && showCheckInButton"
                  @click="
                    showCheckInButton &&
                      updateInheritedBom(
                        inheritedFrom?.bomName,
                        inheritedFrom?.bomVersion
                      )
                  "
                  class="update_button"
                  >update</span
                >
              </div>
            </div>
            <div class="bom-state-chip" :class="getBomState">
              {{ getBomState }}
              {{
                bomState === 3 && getCheckedOutBy !== user.userId
                  ? `by ${userName(getCheckedOutBy)}`
                  : ""
              }}
            </div>
          </div>
          <div class="v-center s">
            <img class="edit" v-tooltip="'Change Status'"
            v-if="!selectedMaterialForLC?.ongoing_lifecycle_workflow_id && user.tenantLevelRole !== 'VIEWER'"
             :class="{ disabled: (selectedMaterialForLC.state === 3 || selectedMaterialForLC.state === 5) }"
            src="~@/assets/images/icons/status-change.svg"
            alt="Status Change"
            width="20"
            @click="openWorkflowSelectionModal()"
            />
            <img  v-if="selectedMaterialForLC?.ongoing_lifecycle_workflow_id" class="edit"
            v-tooltip="'Ongoing Workflow'" width="20"
            :class="{ disabled: !isDisabled }"
            src="~@/assets/images/icons/workflows.svg"
            @click="openWFInstanceModal()"/>

            <img  class="btn ml-3" width="20" src="~@/assets/images/icons/checkIn-file.svg" alt=""
             @click="openNotificationModal('checkin')" v-tooltip="'BOM CheckIn'"
              v-show="showCheckInButton"/>
          <img  v-show="showCheckoutButton"
          width="20"
          src="~@/assets/images/icons/checkout-file.svg"
           :class="{ disabled: !(wfAssignees || user.tenantLevelRole === 'ADMIN') && selectedMaterialForLC?.ongoing_lifecycle_workflow_id }"
            class="btn ml-3"
            v-tooltip="'Checkout BOM'"
            @click="openNotificationModal('checkout')"/>

            <img
            v-show="showUndoCheckoutButton"
              class="btn ml-3"
              width="20"
              v-tooltip="'Undo checkout'"
              src="~@/assets/images/icons/undo-checkout.svg"
              @click="openNotificationModal('undo checkout')"
              :class="{ disabled: bomVersionList.length === 1 }"
              />

            <img class="btn ml-3 pointer" width="20" src="~@/assets/images/icons/history-icon.svg" @click="showBomHistory" alt="" v-tooltip="'Show History'"/>
             <img  class="btn ml-3" width="20" src="~@/assets/images/icons/share.svg" alt=""
             @click="handleShareBom"
              v-show="showShareBomButton" v-tooltip="'Share BOM'"/>

            <button
              v-if="showEditButton"
              class="btn btn-black ml-3"
              @click="editSelected"
            >
              Edit
            </button>
          </div>
        </div>
        <div class="bom-detail-item">
          <div class="copy-dtx-table-wrapper">
            <div class="copy-dtx-table-head">

            <bom-detail-head :headings="visibleHeadings" /> </div>
            <div class="copy-dtx-table-body">
            <bom-detail-body
              :bomId="bomId || null"
              :bomVersionId="bomVersionId"
              :showEdit="showEditButton"
              @bomItemLength="checkBomItemLength"
            /> </div>
            <div class="table-footer">
              <div v-if="showTotalCost" class="footer-right">
                <div class="footer-field">
                  <label>Total Cost:</label>
                  <span>{{ total_cost === 0 ? "0" : total_cost || "--" }}</span>
                </div>
                <div class="footer-field">
                  <label>Sale Price:</label>
                  <span>{{ sale_price === 0 ? "0" : sale_price || "--" }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <bom-comment :closeOnOutsideClick="true"/>
      <modal
      class="impact-notification-modal"
        @close="closeNotificationModal"
        :closeOnOutsideClick="true"
        :open="materialNotification.isOpen"
        title="Products that will be impacted by this change : "
      >
        <div>
          <div class="thiss product-bom">
            <div
              v-if="productCodeData[0]?.core_bom?.product_bom?.product_code"
              :class="{ 'scroll-box': hasData }"
              class=""
            >
              <div
                class="product-bom-card"
                v-for="product in productCodeData"
                :key="product?.id"
              >
                <div v-overflow-tooltip class="elipsis-text">
                  {{ product?.core_bom?.product_bom?.product_code }}
                </div>
              </div>
            </div>
            <div v-else>
              <p class="pb-3">No Products will be affected by this change!</p>
            </div>
          </div>
        </div>
        <div class="modal-buttons mt-5">
          <button
            @click="closeNotificationModal"
            class="btn btn-cancel dialog-cancel mr-2"
          >
            Cancel
          </button>
          <button @click="confirmBomAction" class="btn dialog-ok">Confirm</button>
        </div>
      </modal>
      <modal
        :open="updateInheritedBomModal"
        @close="updateInheritedBomModal = false"
        :closeOnOutsideClick="true"
        title="update to latest version"
      >
        <table class="update-bom-table">
          <thead>
            <th>
              <img
                v-if="selectedAll"
                src="~@/assets/images/icons/checked-icon.svg"
                alt=""
                @click="deselectAll"
              />
              <img
                v-else
                src="~@/assets/images/icons/unchecked-icon.svg"
                alt=""
                @click="selectAll"
              />
            </th>
            <th>Product Code</th>
            <th>Material Id</th>
            <th>Material Name</th>
            <th>Quantity</th>
            <th>Unit Size</th>
            <th>Type</th>
            <th>Material Cost</th>
            <th>Material Price</th>
            <th>Associated Bom</th>
          </thead>
          <tbody>
            <tr
              v-for="(material, index) in newBomData?.bom"
              :key="index"
              :class="{
                deleted: material?.quantity < 1,
                existing: material.state === 'old',
              }"
            >
              <td>
                <span v-if="material.state !== 'old'">
                  <img
                    v-if="material.selected"
                    src="~@/assets/images/icons/checked-icon.svg"
                    alt=""
                    @click="deselect(index)"
                  />
                  <img
                    v-else
                    src="~@/assets/images/icons/unchecked-icon.svg"
                    alt=""
                    @click="selectMaterial(index)"
                  />
                </span>
              </td>
              <td>
                {{ material?.core_material?.material_product_code?.product_code }}
              </td>
              <td>
                {{ material?.core_material?.custom_material_id }}
              </td>

              <td>{{ material?.core_material?.material_name }}</td>
              <td>{{ material?.quantity }}</td>
              <td>{{ material?.unit_size }}</td>
              <td><span v-if="material?.core_material.type === 1">{{ material?.core_material?.material_group_details?.name }}</span>
              <span v-else>{{ material?.core_material?.resource_group_details?.name }}</span></td>
              <td>{{ material?.material_unit_cost }}</td>
              <td>{{ material?.material_unit_sale_price }}</td>
              <td>
                <span v-if="material?.associated_bom_version?.core_bom?.name"
                  >{{ material?.associated_bom_version?.core_bom?.name }} <br />
                  Version-{{ material?.associated_bom_version?.version_no }}</span
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div class="accordion">
          <div>
            <div
              class="accordion-header flex v-center space-between"
              @click="expandSummary = !expandSummary"
            >
              <h4>Summary</h4>
              <span>
                <img
                  v-if="!expandSummary"
                  src="~@/assets/images/icons/arrow-down-icon.svg"
                  height="15px"
                  alt=""
                />
                <img
                  v-else
                  src="~@/assets/images/icons/arrow-up-icon.svg"
                  height="15px"
                  alt=""
                />
              </span>
            </div>
            <div v-if="expandSummary" class="accordion-content">
              <ul class="message-ul">
                <li v-for="(message, index) in newBomData?.message" :key="index">
                  {{ message }}
                </li>
                <!-- <li class="deleted-msg">
            All the materials with quantity less than zero will be deleted
          </li> -->
              </ul>
            </div>
          </div>
        </div>
        <div class="update-btn-box">
          <button class="btn btn-black ml-3" @click="closeModal">Cancel</button>
          <button class="btn ml-3 update-btn" @click="compareAndUpdate">
            Update
          </button>
        </div>
      </modal>
      <modal
        :open="shareBomModal"
        @close="shareBomModal = false"
        :closeOnOutsideClick="true"
        title="Share BOM"
      >
        <share-bom
          v-if="shareBomModal"
          @close="shareBomModal = false"
          :id="bomId"
          :versionId="getLatestVersionId"
          item="bom"
        />
      </modal>
      <modal
        @close="historyModal = false"
        :open="historyModal"
        title="BOM History"
      >
        <div class="material-history-container">
          <div v-if="historyLoader" class="fh fw center loader-conatainer">
            <loading-circle />
          </div>
          <i
            v-else-if="!Object.keys(bomHistory).length"
            class="material-history-box p-3 center"
          >
            History is not available
          </i>
          <div v-else class="material-history-box">
            <div
              v-for="(dateArray, index) in bomHistory"
              :key="index"
              class="material-history-body"
            >
              <div class="material-history-body-dateBox">
                <div class="material-history-body-date">
                  <img src="~@/assets/images/icons/calenderGrey.svg" width="12px" alt="" />
                  {{ dateArray[0].timestamp | timeStampToDate }}
                </div>
                <hr class="material-history-body-date-line" />
              </div>
              <div class="material-history-body-elementsBox">
                <history-element
                  v-for="(item, itemIndex) in dateArray"
                  :key="itemIndex"
                  :data="item"
                  :elementColor="'238, 159, 214'"
                />
              </div>
            </div>
          </div>
        </div>
      </modal>
       <modal
      @close="wfSelectionModal = false"
      :open="wfSelectionModal"
      :title="'Change BOM Status'"
    >
      <div  class="material-history-container">
        <div v-if="wfSelectionLoader.loader" class="fh fw center loader-conatainer">
          <loading-circle />
        </div>
      <wf-selection-lifecycle v-else
      :workflows="filteredWorkflowsData"
      :feature="{ name:'bom', id: selectedMaterialForLC.id, data: selectedMaterialForLC}"
      :cancel="cancelWfSelectionModal"
      :wfModalLoaderController="wfModalLoaderController"
      :emitChanges="emitChanges"
      :panelStyle="'flat'"
      :workflowLoading="wfSelectionLoader.skelton"
       >
       <template
         #actions="{
           statusChangeMode
         }"
       >
      <div v-if="statusChangeMode === 'manual'" class="wf-status-action fh fw">
        <p class="wf-status-action__title">Target Status</p>
        <div class="wf-status-action__grid">
          <button v-if="showCheckInButton" :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active': selectedTargetStatus === 'checkin' }
            ]"
            @click="setSelectedTargetStatus('checkin')">
            CheckIn
          </button>
          <button
          v-if="showLockButton"
            type="button"
            :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active': selectedTargetStatus === 'lock' }
            ]"
            @click="setSelectedTargetStatus('lock')"
          >
            Lock
          </button>
          <button
          v-if="showObsoleteBom"
            type="button"
            :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active': selectedTargetStatus === 'obsolete' }
            ]"
            @click="setSelectedTargetStatus('obsolete')"
          >
            Obsolete
          </button>
           <button v-if="showReleaseButton"  type="button"
            :class="[
              'wf-status-action__btn',
              { 'wf-status-action__btn--active': selectedTargetStatus === 'release' }
            ]"
             @click="setSelectedTargetStatus('release')"
            >
              Release
            </button>
        </div>
        <div class="wf-status-action__footer gap-1">
          <button class="btn" @click="openNotificationModal">Change</button>
        </div>
      </div>
       </template>
       </wf-selection-lifecycle>
      </div>
    </modal>
     <!-- workflow instance modal start  -->
    <modal
      @close="workflowInstanceModal = false"
      :open="workflowInstanceModal"
      :title="'Update BOM'"
    >
                  <workflow-instance-edit-panel
                    :panel-style="'alternate'"
                    v-if="workflowInstanceModal && selectedMaterialForLC.ongoing_lifecycle_workflow_id"
                    ref="WorkflowDetailsPanel"
                    :wfInstanceId="selectedMaterialForLC.ongoing_lifecycle_workflow_id"
                    :feature="Config.CORE_FEATURES.BOM"
                    @goBack="workflowInstanceModal = false"
                    @finishWorkflow="finishWorkflow"
                    @afterWFaction="afterWFAction"
                    @workflowCancelled="workflowCancelled"
                    :Status="bomState"
                  />
    </modal>
    <!-- workflow instance modal  end  -->
    </div>
  </template>

<script>
import {
  ProductCodeStatus,
  GetBomDetailById,
  GetAllBomVersionListByBomId,
  GetBomDetailByIdAndBomVersion,
  lifeCycleStatusUpdate,
  GetAllBomItemsByBomVersionId,
  addComments,
  deleteAllBomItemAndUpdate,
  getWfListBasedOnId
} from '@/api'
import { mapGetters } from 'vuex'
import Modal from '../../../components/common/modal.vue'
import { alert, success } from '@/plugins/notification'
import bomDetailHead from '../../../components/bom/common/copyBomDetailHead.vue'
import BomDetailBody from '../../../components/bom/common/copyBomDetailBody.vue'
// import copyDummy from '@/components/bom/common/copyDummy.vue'
import LoadingCircle from '../../../components/common/loadingCircle.vue'
import BomComment from '../../../components/bom/common/bomComment.vue'
import ShareBom from '../../../components/common/share.vue'
import { GetAllImpactedProductCode } from '../../../api/apis/productCode'
import { compareAndUpdate } from '../../../components/bom/compare/compareAndUpdate'
import ConfirmationDialog from '@/plugins/confirmationDialog'
import wfSelectionLifecycle from '../../../components/workflows/wfSelectionLifecycle.vue'
import Loader from '@/plugins/loader'
import Config from '@/config'
import { getTokenStorage } from '@/api/session'
import { getBomHistory } from '@/api/apis/bom'
import HistoryElement from '@/views/FORM/historyElement.vue'
import workflowInstanceEditPanel from '@/views/FORM/workflowInstanceEditPanel.vue'

export default {
  components: {
    bomDetailHead,
    Modal,
    BomDetailBody,
    LoadingCircle,
    BomComment,
    ShareBom,
    HistoryElement,
    wfSelectionLifecycle,
    workflowInstanceEditPanel
  },
  name: 'bomDetail',
  data: () => ({
    obseleteCheck: false,
    showTotalCost: false, // show/hide total cost based on bom Items
    loadingBomDetail: false,
    bomName: '',
    bomVersionList: [],
    bomVersion: '',
    bomVersionReleased: false,
    bomId: null,
    bomVersionId: '',
    inheritedFrom: null,
    bomState: null,
    productCodeData: [],
    activeBomversion: false,
    materialNotification: {
      isOpen: false,
      action: '',
      productsAndBoms: null
    },
    updateInheritedBomModal: false,
    newBomData: [],
    newInheritedVersionId: null, // saves the bom version id of latest parent
    total_cost: null,
    sale_price: null,
    shareBomModal: false,
    collabarotor: false,
    activeBomversionId: null, // active bom version id ,  used at the time of  update inherited bom,
    selectedAll: true,
    expandSummary: false, // for accordian in update inherit modal modal
    activeBomVersionItems: null, //  stores bom items (materials) of latest version of child bom
    historyLoader: false,
    historyModal: false,
    bomHistory: {},
    wfSelectionModal: false,
    wfSelectionLoader: { loader: false, skelton: false },
    selectedMaterialForLC: {},
    selectedTargetStatus: 'OBSOLETE',
    workflowsData: [],
    Config: Config,
    workflowInstanceModal: false
  }),
  computed: {
    visibleHeadings () {
      return [
        'Product Code',
        'Material ID',
        'PLM ID',
        'ERP ID',
        'UOM',
        'Description',
        'Unit Size',
        'Quantity',
        'Material Name',
        'Lead Time',
        'Remarks',
        'Actions'
      ]
    },
    hasData () {
      return (
          this.productCodeData[0]?.core_bom?.product_bom?.product_code ||
          this.productCodeData?.associated_bom_version?.core_bom?.product_bom
            ?.product_code
      )
    },
    filteredChildTenants () {
      return this.childTenantsList.filter((tenant) => ((tenant.status === 1 || tenant.status === 4) && tenant.target_tenant.status === 1))
    },
    ...mapGetters('productBom', [
      'selectedProductCode',
      'selectedBomId',
      'obsoleteProductCodes'
    ]),
    ...mapGetters(['user', 'getUserById', 'collaborator', 'isOnProjectLevel', 'childTenantsList', 'isExternalCollaborator']),
    getBomState () {
      return Config.STATE_MAP[this.bomState]
    },
    getBomVersionsList () {
      return this.bomVersionList.filter((bomVersion) => {
        return true
      })
    },
    checkoutVersion () {
      return (
        this.bomVersionList.find((bomVersion) => bomVersion.state === 3) || {}
      )
    },
    getCheckedOutBy () {
      return this.checkoutVersion.checked_out_by || null
    },
    showCheckInButton () {
      const role = this.user.tenantLevelRole
      const state = this.bomState
      const roleAllowed = state === Config.BOM_STATE_MAP.CHECKOUT ? ['ADMIN', 'COLLABORATOR', 'EDITOR'] : ['ADMIN', 'COLLABORATOR']
      const hasActiveVersion = this.bomVersionList.some((v) => v.active)
      const isCheckoutAllowed = this.getCheckedOutBy === this.user.userId ||
        (role === 'ADMIN' && !hasActiveVersion)
      const stateAllowed = (state === Config.BOM_STATE_MAP.CHECKOUT && isCheckoutAllowed) || state === Config.BOM_STATE_MAP.LOCK ||
    (role === 'ADMIN' &&
      [Config.BOM_STATE_MAP.RELEASE, Config.BOM_STATE_MAP.OBSOLETE].includes(state))
      return roleAllowed.includes(role) && stateAllowed &&
         this.productCodeStatus === undefined
    },
    showShareBomButton () {
      if (!this.filteredChildTenants.length) {
        return false
      }
      return (
        this.bomState !== Config.BOM_STATE_MAP.OBSOLETE && // this condtion is to ensure the given bom has min one active version if it has onl one version
          !this.collabarotor &&
          (this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'EDITOR' ||
            this.user.tenantLevelRole === 'COLLABORATOR') && this.productCodeStatus === undefined && this.checkVersionList
      )
    },
    // this condtion is to ensure the given bom has min one active version if it has onl one version
    checkVersionList () {
      if (
        this.bomVersionList.length === 1 &&
          this.bomVersionList[0].state === 3
      ) { return false }
      return true
    },

    showCheckoutButton () {
      return (
        this.activeBomversion &&
          this.bomState === 2 &&
          (this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'EDITOR' ||
            this.user.tenantLevelRole === 'COLLABORATOR' || this.collabarotor) &&
          this.productCodeStatus === undefined
      )
    },
    wfAssignees () {
      const groupMember = this.selectedMaterialForLC?.ongoing_lifecycle_workflow?.current_instance_step?.workflow_step?.core_user_group?.core_user_group_members
      const instanceSteps = this.selectedMaterialForLC?.ongoing_lifecycle_workflow?.current_instance_step?.instance_step_assignees
      const exist = groupMember?.some(item => item.user_id === this.user.userId) || instanceSteps?.some(item => item.user_id === this.user.userId)
      return exist
    },
    showLockButton () {
      return (
        this.bomState === 2 &&
          (this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'COLLABORATOR') &&
          this.productCodeStatus === undefined &&
          !this.collabarotor
      )
    },
    showObsoleteBom () {
      return (
        (this.bomState === 2 || this.bomState === Config.BOM_STATE_MAP.LOCK) &&
          this.user.tenantLevelRole === 'ADMIN' &&
          this.productCodeStatus === undefined &&
          !this.collabarotor
      )
    },
    showUnlockButton () {
      return (
        this.bomState === Config.BOM_STATE_MAP.LOCK &&
          (this.user.tenantLevelRole === 'ADMIN' ||
            this.user.tenantLevelRole === 'COLLABORATOR') && !this.collabarotor &&
          this.productCodeStatus === undefined
      )
    },
    showEditButton () {
      return (
        this.bomState === 3 &&
          this.getCheckedOutBy === this.user.userId &&
          this.productCodeStatus === undefined && this.user.tenantLevelRole !== 'VIEWER'
      )
    },
    showReleaseButton () {
      return (
        (this.bomState === 2 || this.bomState === Config.BOM_STATE_MAP.LOCK) &&
          !this.bomVersionReleased &&
          this.activeBomversion &&
          (this.user.tenantLevelRole === 'ADMIN') &&
          this.productCodeStatus === undefined &&
          !this.collaborator
      )
    },
    showNonObsoleteBom () {
      return (
        this.bomState === Config.BOM_STATE_MAP.OBSOLETE &&
          this.user.tenantLevelRole === 'ADMIN' &&
          this.productCodeStatus === undefined
      )
    },
    showUndoCheckoutButton () {
      return (
        (this.getCheckedOutBy === this.user.userId ||
           (this.user.tenantLevelRole === 'ADMIN' && !this.collabarotor)) &&
          this.bomState === 3 &&
          this.productCodeStatus === undefined && this.user.tenantLevelRole !== 'VIEWER'
      )
    },
    productCodeStatus () {
      return this.obsoleteProductCodes[this.selectedProductCode]
    },
    getLatestVersionId () {
      for (const version of this.bomVersionList) {
        if (version.active) {
          return version.id
        }
      }
      return null
    },
    isDisabled () {
      return this.canAccessOngoingWorkflow()
    },
    filteredWorkflowsData () {
      return this.getUserApplicableWorkflows(this.workflowsData)
    }
  },
  watch: {
    '$route.params.bomId': {
      handler (newVal, oldVal) {
        if (newVal !== oldVal) {
          this.setup()
        }
      },
      immediate: true
    },
    bomVersionId () {
      this.activeBomversion = false
      for (const version of this.bomVersionList) {
        if (version.id === this.bomVersionId && version.active) {
          this.activeBomversion = true
        }
      }
    }
  },
  methods: {
    openWFInstanceModal () {
      if (!this.canAccessOngoingWorkflow()) {
        return
      }
      this.workflowInstanceModal = true
    },
    finishWorkflow () {
      this.$refs.WorkflowDetailsPanel.updateWorkflowMaterial(true)
    },
    afterWFAction (closeWFT) {
      if (closeWFT) {
        this.selectedMaterialForLC.ongoing_lifecycle_workflow_id = null
        this.emitChanges(this.selectedMaterialForLC.index, this.selectedMaterialForLC)
      }
      this.$store.dispatch('productBom/getAllBomList')
      this.setup()
    },
    workflowCancelled (workflowMessage) {
      this.selectedMaterialForLC.ongoing_lifecycle_workflow_id = null
      const triggerUpdates = workflowMessage?.trigger_action_updates
      if (triggerUpdates) {
        const nextState = triggerUpdates.state ?? triggerUpdates.status
        if (nextState !== undefined && nextState !== null) {
          this.selectedMaterialForLC.state = nextState
          this.bomState = nextState
        }
      }
      this.emitChanges(this.selectedMaterialForLC.index, this.selectedMaterialForLC)
      this.$store.dispatch('productBom/getAllBomList')
      this.setup()
      this.workflowInstanceModal = false
    },
    setSelectedTargetStatus (status) {
      this.selectedTargetStatus = status
    },
    cancelWfSelectionModal () {
      this.wfSelectionModal = false
      this.selectedMaterialForLC = {}
      this.$store.dispatch('productBom/getAllBomList')
      this.setup()
    },
    emitChanges (index, materialMasterTemp) {
      this.$emit('updateList', {
        data: materialMasterTemp,
        index
        // eslint-disable-next-line indent
                })
    },
    canCurrentUserStartWorkflow (workflow) {
      if (!this.user?.userId) {
        return false
      }
      return (workflow?.start_steps ?? []).some((step) =>
        step?.user_group?.core_user_group_members?.some((member) => member?.user_id === this.user.userId)
      )
    },
    isEditorOrCollaboratorUser () {
      return (
        this.collabarotor ||
        this.collaborator ||
        this.isExternalCollaborator ||
        this.user?.tenantLevelRole === 'EDITOR' ||
        this.user?.tenantLevelRole === 'COLLABORATOR' ||
        this.user?.projectLevelRole === 'EDITOR' ||
        this.user?.projectLevelRole === 'COLLABORATOR'
      )
    },
    canAccessOngoingWorkflow () {
      if (this.user?.tenantLevelRole === 'ADMIN' || this.user?.projectLevelRole === 'ADMIN') {
        return true
      }
      if (!this.selectedMaterialForLC?.ongoing_lifecycle_workflow_id) {
        return true
      }
      if (this.isEditorOrCollaboratorUser()) {
        return this.wfAssignees
      }
      return this.wfAssignees
    },
    getUserApplicableWorkflows (workflows) {
      if (this.user?.tenantLevelRole === 'ADMIN' || this.user?.projectLevelRole === 'ADMIN') {
        return workflows ?? []
      }
      return (workflows ?? []).filter((workflow) => this.canCurrentUserStartWorkflow(workflow))
    },
    openWorkflowSelectionModal () {
      this.wfSelectionModal = true
      this.wfSelectionLoader.skelton = true
      this.selectedTargetStatus = null
      getWfListBasedOnId({ bomId: this.bomId, category: Config.WORKFLOW_SUB_CATE.LIFECYCLE })
        .then((res) => {
          this.workflowsData = res.get_applicable_workflows.message ?? []
          this.wfSelectionLoader.skelton = false
        })
        .catch(() => {
          this.wfSelectionLoader.skelton = false
        })
    },
    wfModalLoaderController ({ start = null, stop = null }) {
      if (start) {
        this.wfSelectionLoader.loader = true
      }
      if (stop) {
        this.wfSelectionLoader.loader = false
      }
      this.$store.dispatch('productBom/getAllBomList')
      this.setup()
    },
    deselect (index) {
      this.selectedAll = false
      this.newBomData.bom[index].selected = false
      this.newBomData = { ...this.newBomData }
    },
    selectMaterial (index) {
      this.newBomData.bom[index].selected = true
      let flag = true
      this.newBomData.bom.forEach((material) => {
        if (material?.state !== 'old' && material.quantity > 0) {
          if (material?.selected) {
          } else {
            flag = false
          }
        }
      })
      if (flag) {
        this.selectedAll = true
      }
      this.newBomData = { ...this.newBomData }
    },
    deselectAll () {
      this.selectedAll = false
      this.newBomData.bom = this.newBomData.bom.map((material) => {
        if (material?.state !== 'old' && material.quantity > 0) {
          return { ...material, selected: false }
        } else {
          return material
        }
      })
    },
    selectAll () {
      this.selectedAll = true
      this.newBomData.bom = this.newBomData.bom.map((material) => {
        if (material?.state !== 'old' && material.quantity > 0) {
          return { ...material, selected: true }
        } else {
          return material
        }
      })
    },
    checkBomItemLength (length) {
      if (length > 0) {
        this.showTotalCost = true
      }
    },
    openNotificationModal (status) {
      this.materialNotification.action = this.selectedTargetStatus
      if (status === 'checkin') return this.checkInBom()
      if (status === 'checkout') return this.checkoutBom()
      if (status === 'undo checkout') return this.undoCheckout()
      if (!this.materialNotification.action) {
        alert('Please select the valid status')
        return
      }

      GetAllImpactedProductCode(this.bomId).then((data) => {
        this.productCodeData = data.bom_versions
      })

      this.materialNotification.isOpen = true
    },
    closeNotificationModal () {
      this.materialNotification.isOpen = false
    },
    confirmBomAction () {
      if (this.materialNotification.action === 'checkin') {
        this.checkInBom()
      } else if (this.materialNotification.action === 'obsolete') {
        this.obsoleteBom()
      } else if (this.materialNotification.action === 'lock') {
        this.lockBom()
      } else if (this.materialNotification.action === 'release') {
        this.releaseBom()
      }
      this.wfSelectionModal = false
      this.materialNotification.isOpen = false
    },
    userName (userId) {
      const user = this.getUserById(userId)
      const userDetail = user?.associated_user
      return (
        (
          (userDetail?.first_name || '') +
            ' ' +
            (userDetail?.last_name || '')
        ).trim() || 'DTX User'
      )
    },
    checkInBom () {
      this.loadingBomDetail = true
      lifeCycleStatusUpdate({ bomId: this.selectedBomId, status: 2 }).then(() => {
        this.$store.dispatch('productBom/getAllBomList')
        addComments(
          'bom',
          this.bomId,
          'BOM Checked In',
          null,
          this.bomVersionId
        )
        success('BOM CheckedIn Successfully')
        this.setup()
      })
        .catch((error) => {
          this.loadingBomDetail = false
          alert(error.message ?? 'failed to fetch the data')
        })
    },
    undoCheckout () {
      this.loadingBomDetail = true
      lifeCycleStatusUpdate({ bomId: this.selectedBomId, status: 2, undoCheckout: true }).then(() => {
        this.$store.dispatch('productBom/getAllBomList')
        addComments('bom', this.bomId, 'BOM Undo Checkout', null, null)
        this.setup()
        success('BOM Undo Checkout Successfully')
      }).catch((err) => {
        this.loadingBomDetail = false
        alert(err.message ?? 'failed to fetch the data')
      })
    },
    checkoutBom () {
      this.loadingBomDetail = true
      const latestBomVersion = this.bomVersionList.sort((a, b) => {
        return b.version - a.version
      })[0]
      GetAllBomItemsByBomVersionId(latestBomVersion.id).then((res) => {
        const bomItems = res.bom_items || []
        bomItems.forEach((bomItem) => {
          delete bomItem.core_material
          delete bomItem.__typename
          delete bomItem.associated_bom_version
          delete bomItem.bom_version
          bomItem.bom_id = this.selectedBomId
        })

        lifeCycleStatusUpdate({ bomId: this.selectedBomId, status: 3 }).then(() => {
          this.$store.dispatch('productBom/getAllBomList')
          addComments(
            'bom',
            this.bomId,
            'BOM Checked Out',
            null,
            this.bomVersionId
          )
          this.setup()
          success('BOM Checked Out Successfully')
        }).catch((err) => {
          this.loadingBomDetail = false
          alert(err.message ?? 'failed to fetch the data')
        })
      })
    },
    lockBom () {
      this.loadingBomDetail = true
      lifeCycleStatusUpdate({ bomId: this.selectedBomId, status: Config.BOM_STATE_MAP.LOCK }).then(() => {
        this.$store.dispatch('productBom/getAllBomList')
        addComments('bom', this.bomId, 'BOM Locked', null, this.bomVersionId)
        this.setup()
        success('BOM Locked Successfully')
      })
    },
    unLockBom () {
      this.loadingBomDetail = true

      lifeCycleStatusUpdate({ bomId: this.selectedBomId, status: 2 }).then(() => {
        this.$store.dispatch('productBom/getAllBomList')
        addComments('bom', this.bomId, 'BOM Unlocked', null, this.bomVersionId)
        this.setup()
        success('BOM unlocked Successfully')
      })
    },
    obsoleteBom () {
      this.loadingBomDetail = true
      lifeCycleStatusUpdate({ bomId: this.selectedBomId, status: Config.BOM_STATE_MAP.OBSOLETE }).then(() => {
        this.$store.dispatch('productBom/getAllBomList')
        addComments(
          'bom',
          this.bomId,
          'BOM Obsoleted',
          null,
          this.bomVersionId
        )
        this.setup()
        success('BOM obsolete Successfully')
      })
    },
    nonObsoleteBom () {
      this.loadingBomDetail = true
      lifeCycleStatusUpdate({ bomId: this.selectedBomId, status: 2 }).then(() => {
        this.$store.dispatch('productBom/getAllBomList')
        addComments(
          'bom',
          this.bomId,
          'BOM Non-Obsoleted',
          null,
          this.bomVersionId
        )
        this.setup()
        success('BOM nonObsolete Successfully')
      })
    },
    goBack () {
      this.$router.push(`/bom/product/${this.selectedProductCode}`)
    },
    goToBomDetail (bom) {
      this.$router
        .push(
            `/bom/product/${this.selectedProductCode}/copy-bom/${bom.id}${
              bom.bom_versions?.[0].id
                ? `?bomVersionId=${bom.bom_versions?.[0].id}`
                : ''
            }`
        )
        .catch(() => {})
    },
    editSelected () {
      this.$router.push(
          `/bom/product/${this.selectedProductCode}/bom/${this.selectedBomId}/edit`
      )
    },
    changeBomVersion () {
      const bomVersion = this.bomVersionList.find(
        (bomVersion) => bomVersion.id === this.bomVersionId
      )
      if (bomVersion.active) {
        this.loadingBomDetail = true
        //    GetBomDetailById(this.selectedBomId) this was the previous query by this query , if the bom in checkout // state not showing latest version with previous query
        GetBomDetailByIdAndBomVersion(
          this.selectedBomId,
          this.bomVersionId
        ).then((res) => {
          const bomDetail = res.core_bom_by_pk
          this.setBomDetail(bomDetail)
          this.loadingBomDetail = false
        })
      } else {
        this.loadingBomDetail = true
        GetBomDetailByIdAndBomVersion(
          this.selectedBomId,
          this.bomVersionId
        ).then((res) => {
          const bomDetail = res.core_bom_by_pk
          this.setBomDetail(bomDetail)
          this.loadingBomDetail = false
        })
      }
    },
    setBomDetail (bomDetail) {
      this.bomName = bomDetail.name
      this.bomId = bomDetail.id
      this.sale_price = bomDetail.bom_versions?.[0]?.sale_price
      this.total_cost = bomDetail.bom_versions?.[0]?.total_cost
      this.bomVersionId = bomDetail.bom_versions?.[0]?.id
      this.bomVersion = bomDetail.bom_versions?.[0]?.version_no
      this.bomState = bomDetail.state || 2
      this.bomVersionReleased = bomDetail.bom_versions?.[0]?.released || false
      this.selectedMaterialForLC = bomDetail
      if (bomDetail.inherited_bom_version) {
        this.inheritedFrom = {
          bomId: bomDetail.inherited_bom_version?.core_bom?.id,
          bomName: bomDetail.inherited_bom_version?.core_bom?.name,
          bomVersionId: bomDetail.inherited_bom_version?.id,
          bomVersion: bomDetail.inherited_bom_version?.version_no,
          bomVersionActive: bomDetail.inherited_bom_version?.active
        }
      } else {
        this.inheritedFrom = null
      }
      this.$router
        .push(
            `/bom/product/${this.selectedProductCode}/copy-bom/${this.selectedBomId}${
              this.bomVersionId ? `?bomVersionId=${this.bomVersionId}` : ''
            }`
        )
        .catch(() => {})
    },
    releaseBom () {
      lifeCycleStatusUpdate({ bomId: this.selectedBomId, status: 5 }).then(() => {
        this.$store.dispatch('productBom/getAllBomList')
        addComments('bom', this.bomId, 'BOM Released', null, this.bomVersionId)

        this.setup()
        success('BOM released Successfully')
      })
    },
    setup () {
      this.loadingBomDetail = true
      this.bomVersionList = []
      this.bomVersionId = ''
      this.bomVersion = ''
      this.inheritedFrom = null
      this.bomState = 2
      const productCode = this.$route.params.productCode
      GetBomDetailById(this.selectedBomId).then((res) => {
        const bomDetail = res.core_bom_by_pk
        bomDetail.bom_versions = bomDetail.bom_versions.filter((bomVersion) => {
          if (this.user.tenantLevelRole !== 'ADMIN') {
            if (bomVersion.state === 3) {
              if (bomVersion.checked_out_by !== this.user.userId) {
                return false
              }
            }
          }
          return true
        })
        ProductCodeStatus(productCode).then(res => {
          if (res?.core_material_master[0]?.status === 2) {
            this.obseleteCheck = true
          } else this.obseleteCheck = false
        })
        this.setBomDetail(bomDetail)
        this.loadingBomDetail = false
        GetAllBomVersionListByBomId(this.selectedBomId).then((res) => {
          this.bomVersionList = res.bom_versions || []
          if (this.bomVersionId) {
            this.activeBomversion = false
            for (const version of this.bomVersionList) {
              if (version.id === this.bomVersionId && version.active) {
                this.activeBomversion = true
              }
            }
          }
        })
      })
    },
    updateInheritedBom (bomName, bomVersion) {
      // bomName, bomVersion are parent details
      if (this.bomVersion === 1) {
        alert(
            `There is no active verison for  " ${this.bomName.toUpperCase()} " to update `
        )
        return
      }
      ConfirmationDialog(
          `Are you sure to update  from  V-${bomVersion} of  ${bomName} to latest version`,
          (res) => {
            if (res) {
              this.checkandUpdateBOM()
            }
          },
          'Update',
          'Cancel',
          'Update Bom'
      )
    },
    // this function is to check inherited (current-bom) to its parent bom(from where current bom get inherited) and updte
    checkandUpdateBOM () {
      // getting parent bom itmes data
      const loader = new Loader()
      try {
        loader.show()
        GetBomDetailById(this.inheritedFrom.bomId).then((data) => {
          for (let i = 0; i < this.bomVersionList.length; i++) {
            if (this.bomVersionList[i]?.active) {
              this.activeBomversionId = this.bomVersionList[i]?.id
              break
            }
          }
          const child = GetAllBomItemsByBomVersionId(this.activeBomversionId)
          // this loop to get the latest  active version of parent  bom and to exclude if latest version is in check out state
          for (let i = 0; i < data?.core_bom_by_pk?.bom_versions.length; i++) {
            if (data?.core_bom_by_pk?.bom_versions[i]?.active) {
              this.newInheritedVersionId =
                  data?.core_bom_by_pk?.bom_versions[i]?.id
              break
            }
          }
          const parentLatest = GetAllBomItemsByBomVersionId(
            // data?.core_bom_by_pk?.bom_versions[0]?.id
            this.newInheritedVersionId
          )
          const parentInitail = GetAllBomItemsByBomVersionId(
              this.inheritedFrom?.bomVersionId
          )
          Promise.allSettled([parentLatest, parentInitail, child]).then(
            (data) => {
              const [parentBomLatest, parentBomInitail, childBom] = data
              this.activeBomVersionItems = JSON.parse(JSON.stringify(childBom?.value?.bom_items))
              this.newBomData = compareAndUpdate(
                  parentBomLatest?.value?.bom_items,
                  parentBomInitail?.value?.bom_items,
                  childBom?.value?.bom_items
              )
              this.newBomData.bom = this.newBomData.bom.map((mat) => {
                mat.selected = true
                return mat
              })
              this.updateInheritedBomModal = true
              loader.hide()
            }
          )
        })
      } catch (error) {
        loader.hide()
        alert('something went wrong')
      }
    },
    compareAndUpdate () {
      const loader = new Loader()
      loader.show()
      try {
        this.updateInheritedBomModal = false
        const bomItems = []
        this.newBomData.bom.forEach((bomItem) => {
          if (bomItem?.quantity > 0 && bomItem.selected) {
            // to remove all material with quantity greater than zero
            bomItems.push({
              material_id: bomItem.material_id,
              quantity: bomItem?.quantity,
              total_price: bomItem?.total_price,
              unit_size: bomItem?.unit_size,
              material_group: bomItem?.material_group,
              material_unit_cost: bomItem?.material_unit_cost,
              material_unit_sale_price: bomItem?.material_unit_sale_price,
              associated_product_code_bom: bomItem.associated_product_code_bom,
              bom_id: this.bomId,
              bom_version_id: this.bomVersionId
            })
          } else if (!bomItem.selected) {
            let revisedData = null
            for (const element of this.activeBomVersionItems) {
              if (element.material_id === bomItem.material_id) {
                revisedData = element
                break
              }
            }
            if (revisedData) {
              bomItems.push({
                material_id: revisedData.material_id,
                quantity: revisedData?.quantity,
                total_price: revisedData?.total_price,
                unit_size: revisedData?.unit_size,
                material_group: revisedData?.material_group,
                material_unit_cost: revisedData?.material_unit_cost,
                material_unit_sale_price: revisedData?.material_unit_sale_price,
                associated_product_code_bom: revisedData.associated_product_code_bom,
                bom_id: this.bomId,
                bom_version_id: this.bomVersionId
              })
            }
          }
        })
        deleteAllBomItemAndUpdate(
          this.bomId,
          this.bomVersionId,
          bomItems,
          this.newInheritedVersionId,
          false
        )
          .then((response) => {
            this.checkInBom()
            loader.hide()
            success('BOM updated Successfully')
          })
          .catch((error) => {
            console.log(error)
            loader.hide()
            alert('Something went wrong')
          })
      } catch (error) {
        loader.hide()
        alert('Something went wrong')
        console.log(error)
      }
    },
    closeModal () {
      this.updateInheritedBomModal = false
    },
    showBomHistory () {
      this.historyModal = true
      this.historyLoader = true
      getBomHistory(this.bomId, this.isOnProjectLevel)
        .then((res) => {
          this.bomHistory = {}
          const history = res?.message?.message
          for (const item of history ?? []) {
            const date = new Date(item.timestamp)
            const dateStr = date.toISOString().split('T')[0]
            switch (item.state) {
            case 'STARTED':
              item.elementColor = Config.elementColor.green
              break
            case 'CLOSED':
              item.elementColor = Config.elementColor.orange
              break
            case 'ASSIGNED':
              item.elementColor = Config.elementColor.blue
              break
            case 'CANCELLED':
              item.elementColor = Config.elementColor.red
              break
            case 'UPDATED':
              item.elementColor = Config.elementColor.purple
              break
            case 'INSERTED':
              item.elementColor = Config.elementColor.green
              break
            default:
              item.elementColor = Config.elementColor.blue
              break
            }
            if (!this.bomHistory[dateStr]) {
              this.bomHistory[dateStr] = []
            }
            this.bomHistory[dateStr].push(item)
          }
          console.log(this.bomHistory)
          this.historyLoader = false
        })
        .catch(() => {
          this.historyLoader = false
        })
    },
    handleShareBom () {
      if (this.getLatestVersionId) {
        this.shareBomModal = true
      } else {
        alert(`There is no active verison for  " ${this.bomName.toUpperCase()} " to share `)
      }
    }
  },
  created () {
    this.setup()
    const storage = getTokenStorage()
    this.collabarotor =
        storage.getItem(Config.localstorageKeys.COLLABORATOR) === 'true'
  }
}
</script>

  <style lang="scss" scoped>
  .product-bom {
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-content: center;
    align-items: center;
    &-card {
      position: relative;
      height: 40px;
      width: 80px;
      font-size: var(--text-base);
      background-color: var(--brand-light-color);
      line-height: 1;
      border: 1px solid var(--brand-color);
      border-radius: 8px;
      margin: 10px;
      font-weight: 500;
      padding: 10px;
      // word-break: break-word;
      text-align: center;
    }
  }
  .thiss {
    padding: 20px;
  }

  // .scroll-box {
  //   padding: 8px;
  //   max-height: 150px;
  //   overflow-y: auto;
  // }
  .modal-buttons {
    display: flex;
    justify-content: flex-end;
  }
  .bom-detail {
    height: 100%;
    &-version {
      margin: 0 0 0 10px;
      font-size: var(--text-s);
      background-color: var(--brand-light-color);
      line-height: 1;
      border: 1px solid var(--brand-color);
      border-radius: 4px;
      padding: 4px 12px;
    }
    table {
      width: 100%;
      position: relative;
      border-collapse: collapse;

      th {
        position: sticky;
        top: -1px;
        font-weight: 500;
        background-color: var(--brand-color);
      }

      th,
      td {
        text-align: left;
        font-size: var(--text-s);
        padding: 8px 4px;
      }

      tr:nth-child(odd) {
        background-color: rgba(var(--brand-rgb), 0.05);
        border: 1px solid var(--brand-color);
      }
      tr:last-child {
        border-bottom: 1px solid var(--brand-color);
      }
    }
    &-bar {
      padding: 4px 12px;
      padding-left: 0;
      &-title {
        font-size: var(--text-l);
        font-weight: 500;
      }
    }
    .bom-state-chip {
      font-size: var(--text-s);
      line-height: 1;
      padding: 6px 12px;
      border-radius: 2em;
      font-weight: 500;
      &.CHECKIN {
        border: 1px solid var(--success);
        color: var(--success);
        background: #00ff002a;
        margin-inline: 1em;
      }
      &.CHECKOUT {
        border: 1px solid var(--warning);
        color: var(--warning);
        background: #ffff002a;
        margin-inline: 1em;
      }
      &.LOCK {
        border: 1px solid var(--alert);
        color: var(--alert);
        background: #ff00002a;
        margin-inline: 1em;
      }
      &.OBSOLETE {
        border: 1px solid var(--alert);
        color: var(--alert);
        background: #ff00002a;
        margin-inline: 1em;
      }
      &.RELEASED {
        border: 1px solid #1c56b6;
        color: #133e84;
        background: #dde6f4;
        margin-inline: 1em;
      }
    }
    &-item {
      height: calc(100% - 40px);
      overflow-y: auto;
    }
    .inherit {
      cursor: pointer;
      position: relative;
      height: 22px;
      &:hover {
        .inherit-message {
          display: block;
        }
      }
      &-message {
        width: 200px;
        position: absolute;
        display: none;
        top: calc(100% + 10px);
        left: 0;
        background-color: var(--bg-color);
        color: #000;
        font-size: var(--text-s);
        font-weight: 400;
        z-index: 3;
        padding: 4px 12px;
        transform: translate(-50%, 0);
        filter: drop-shadow(0 0 2px rgba(0, 0, 0, 0.5));
        &::before {
          content: "";
          position: absolute;
          top: 0;
          left: 50%;
          transform: translate(50%, -100%);
          border: 5px solid transparent;
          border-bottom-color: var(--bg-color);
        }

        & a {
          color: rgb(0, 140, 255);
          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }
  table {
    width: 100%;
    position: relative;
    border-collapse: collapse;

    th {
      position: sticky;
      top: -1px;
      font-weight: 500;
      background-color: var(--brand-color);
    }

    th,
    td {
      text-align: center;
      font-size: var(--text-l);
      padding: 8px 4px;
    }

    tr:nth-child(odd) {
      background-color: rgba(var(--brand-rgb), 0.05);
      border: 1px solid var(--brand-color);
    }
    .deleted {
      color: red;
    }
  }
  .message-ul {
    height: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 5px;
    padding-inline: 20px;
    & li {
      list-style-type: disc;
    }
  }
  .update-btn-box {
    display: flex;
    justify-content: flex-end;
  }
  .deleted-msg {
    color: red;
  }
  .table-footer {
    display: flex;
    justify-content: flex-start;
    padding: 10px;
    .footer-right {
      display: flex;
      flex-direction: row-reverse;
    }
    .footer-field {
      margin-left: 10px;
      label {
        margin-right: 5px;
        font-weight: bold;
      }
    }
  }
  .update_button {
    color: #008cff;
  }
  .update_button:hover {
    text-decoration-line: underline;
  }
  .elipsis-text {
    text-wrap: nowrap;
  }
  .existing {
    background-color: rgb(219 212 212) !important;
  }
  .material-history {
    &-container {
      display: flex;
      justify-content: center;
      align-items: center;
      min-width: 300px;
      & .loader-conatainer {
        min-width: 300px;
        min-height: 300px;
      }
    }
    &-box {
      width: 100%;
      height: 100%;
    }
    &-body {
      margin-top: 1.5em;
      padding: 5px;
      &-dateBox {
        display: flex;
        gap: 10px;
        align-items: center;
        font-size: 0.8em;
      }
      &-date {
        display: flex;
        align-items: center;
        gap: 5px;
        color: #b5b4b4;
      }
      &-date-line {
        flex-grow: 1;
        border: none;
        height: 0.5px;
        background-color: #cccccc81;
      }
      &-elementsBox {
        padding: 5px;
        overflow: auto;
      }
    }
  }
  .accordion {
    width: 100%;
    border: 1px groove var(--brand-color);
    border-radius: 6px;
    margin: 10px 0px;
    max-height: 22vh;
    animation: myAnim 2s ease 0s 1 normal forwards;
  }

  .accordion-item {
    margin-bottom: 1rem;
    border-radius: 6px;
  }

  .accordion-header {
    padding-inline: 1.5rem;
    height: 2.5rem;
    cursor: pointer;
    border-bottom: 0.8px solid rgba(199, 197, 194, 0.5);
  }

  .accordion-content {
    padding: 0.5rem 0 1rem 1rem;
    animation: myAnim 2s ease 0s 1 normal forwards;
  }

  .bounce-enter-active {
    animation: bounce-in 0.3s;
  }
  .bounce-leave-active {
    animation: bounce-in 0.3s reverse;
  }

  @keyframes myAnim {
    0% {
      opacity: 0;
      transform: rotateX(-100deg);
      transform-origin: top;
    }

    100% {
      opacity: 1;
      transform: rotateX(0deg);
      transform-origin: top;
    }
  }
  @keyframes bounce-in {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  .impact-notification-modal{
  z-index: 3000 !important;
}
  .wf-status-action {
  border: 1px solid #e2e8f0;
  background: #f8fafc;
  border-radius: 8px;
  padding: 12px;
  margin-bottom: 12px;
  min-width: 400px;

  &__title {
    margin: 0 0 10px;
    text-transform: uppercase;
    color: #64748b;
    letter-spacing: 0.6px;
    font-size: var(--text-xs2);
    font-weight: 600;
  }

  &__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(120px, 1fr));
    gap: 10px;
    width: 100%;
  }

  &__btn {
    width: 100%;
    min-height: 34px;
    border-radius: 7px;
    border: 1px solid #d0d7e2;
    background: #f1f5f9;
    color: #4b5563;
    font-size: var(--text-xs1);
    font-weight: 700;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;
  }

  &__btn:hover {
    transform: translateY(-1px);
  }

  &__btn--active {
    border-color: #0f172a;
    background: #0f172a;
    color: #ffffff;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.05);
  }

  &__footer {
    width:100%;
    margin-top: 10px;
    display: flex;
    justify-content: flex-end;
  }
}
.disabled {
  opacity: 0.45;
  pointer-events: none;
  cursor: not-allowed;
}
  @media (max-width: 768px) {
  .wf-status-action {
    min-width:300px
    &__grid {
      grid-template-columns: 1fr;
    }
  }
}
  </style>
